export default __webpack_public_path__ + "static/media/Armguards of the Crimson Fort.55aff2b5.jpg";